import 'luminate/src/main'
import './extensions/toggler'

import ClickBlur from './components/click-blur'
import Scroll from './components/scroll'
import Image from './components/image'
import Autosize from './components/autosize'

ClickBlur()
Scroll()
Image()
Autosize()

import FloatLabel from './modules/float-label'
import Sticky from './modules/sticky'
import ScrollMarker from './modules/scroll-marker'
import Slick from './modules/slick'

Lum.register(FloatLabel)
Lum.register(Sticky)
Lum.register(ScrollMarker)
Lum.register(Slick)



/** WEBPACK FOOTER **
 ** ./source/scripts/main.js
 **/